<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="e-common-lr">
                    <div class="e-left">
                        <img src="@/assets/images/e-tjx-gdty-icon@2x.png" alt="">
                    </div>
                    <div class="e-right">
                        <h3>高端体检服务</h3>
                        <p>高端体检服务为您的健康保驾护航,您也可转让您的亲友使用。</p>
                    </div>
                </div>
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>钛金鑫卡持卡人全年尊享1次高端体检服务,并可转赠亲友使用。本行将在您激活人民币卡后的3个工作日内为您开通权益服务。</p>
                <p class="bold">细则2</p>
                <p>体检服务时间为：每周二(8:00-16:30),节假日服务时间将根据供应商安排另行调整。</p>
                <p class="bold">细则3</p>
                <p>当您需要预约高端体检服务时,请提前7个工作日通过本行信用卡微信公众号权益平台预约服务；供应商将在您生成二维码后三个工作日内联系您预留的电话号码,确认订单详情。如您需要修改或取消该服务,请务必提前2个工作日通过信用卡微信公众号权益平台取消,否则视作您已使用本次服务,并扣减相应权益。
                </p>
                <p class="bold">细则4</p>
                <p>为确保体检结果的准确性,请体检使用人员务必于体检当日上午9点前到达体检中心登记,并出示使用人身份证明文件,上午10点以后体检中心有权不再接受登记。</p>
                <p class="bold">细则5</p>
                <p>体检人在体检当日需留下有效的收件人信息及地址；体检中心将在体检工作全部结束后7到10个工作日内,将体检报告以书面形式快递至该地址。</p>
                <p class="bold">细则6</p>
                <p>体检中心地址：上海市浦东新区康新公路4358号上海国际医学中心体检中心。</p>
            </div>
            <div class="banner-detail-btn" @click="gdtjPush"><img src="@/assets/images/tjx/banner_tjx_gdtj.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            gdtjPush() {
                this.$test('tjx gdtj-banner')
                // console.log('钛金鑫高端体检服务')
                this.$router.push('/servicetable/gdtj')
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>